






































































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { BibliographySetDetailBibliography } from '@/api'
import { CollectionFlag } from '@/types'
import IconBibliography from '@/components/molecules/IconBibliography/IconBibliography.vue'
@Component({
  components: { IconBibliography }
})
export default class BibliographySetInfo extends ComponentVue {
  @Prop({
    type: Object,
    required: true
  })
  input!: BibliographySetDetailBibliography

  get displayBibliographyId() {
    return (
      this.input.prefix + this.input.bibliographyId.toString().padStart(10, '0')
    )
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }
}
